export const services = [
  {
    id: 1,
    title: "AI Solutions",
    slug: "ai-solutions",
    description: "Transform your business with cutting-edge artificial intelligence and machine learning solutions tailored to your needs.",
    icon: "brain",
    image: "https://images.unsplash.com/photo-1697577418970-95d99b5a55cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlfGVufDB8fHx8MTc2MzkzMTUwOXww&ixlib=rb-4.1.0&q=85",
    features: ["Machine Learning Models", "Natural Language Processing", "Computer Vision", "Predictive Analytics", "AI Strategy & Consulting"]
  },
  {
    id: 2,
    title: "Software Development",
    slug: "software-development",
    description: "Full-stack software development services from concept to deployment. We build scalable, secure applications.",
    icon: "code",
    image: "https://images.unsplash.com/photo-1557562645-4eee56b29bc1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxtYWNoaW5lJTIwbGVhcm5pbmd8ZW58MHx8fHwxNzYzOTMxNTE1fDA&ixlib=rb-4.1.0&q=85",
    features: ["Full-Stack Development", "Backend Engineering", "Frontend Development", "Mobile Apps", "API Development"]
  },
  {
    id: 3,
    title: "Data Science",
    slug: "data-science",
    description: "Unlock insights from your data with advanced analytics, visualization, and data engineering solutions.",
    icon: "database",
    image: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlfGVufDB8fHx8MTc2MzkzMTUwOXww&ixlib=rb-4.1.0&q=85",
    features: ["Data Analytics", "Big Data Solutions", "Data Visualization", "ETL Pipelines", "Business Intelligence"]
  },
  {
    id: 4,
    title: "Cloud Services",
    slug: "cloud-services",
    description: "Accelerate your cloud journey with expert guidance. From migration to optimization, we ensure seamless transformation.",
    icon: "cloud",
    image: "https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjbG91ZCUyMGNvbXB1dGluZ3xlbnwwfHx8fDE3NjM5MzExMzF8MA&ixlib=rb-4.1.0&q=85",
    features: ["Cloud Migration", "AWS/Azure/GCP", "Infrastructure as Code", "DevOps & CI/CD", "Cloud Security"]
  },
  {
    id: 5,
    title: "Cybersecurity",
    slug: "cybersecurity",
    description: "Protect your business with comprehensive security solutions. We safeguard your digital assets and ensure compliance.",
    icon: "shield",
    image: "https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg",
    features: ["Security Assessment", "Penetration Testing", "Threat Management", "Compliance & Governance", "Incident Response"]
  },
  {
    id: 6,
    title: "Talent Solutions",
    slug: "talent-solutions",
    description: "Access top-tier IT professionals for your projects. We provide scalable staffing solutions from contract to full-time.",
    icon: "users",
    image: "https://images.unsplash.com/photo-1758518731468-98e90ffd7430?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzYzOTMxMDk3fDA&ixlib=rb-4.1.0&q=85",
    features: ["Contract Staffing", "Direct Placement", "Project Teams", "Staff Augmentation", "Technical Recruiting"]
  }
];

export const products = [
  {
    id: 1,
    name: "HealthConnect AI",
    slug: "healthconnect-ai",
    category: "Healthcare SaaS",
    tagline: "AI-Powered Patient Care Management Platform",
    description: "HealthConnect AI is a comprehensive SaaS platform that revolutionizes healthcare delivery with AI-powered patient management, telemedicine, and predictive analytics.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NjM5MzExMDl8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "AI-Driven Patient Diagnosis Support",
      "Telemedicine Integration",
      "Electronic Health Records (EHR)",
      "Appointment Scheduling & Management",
      "Prescription Management",
      "Patient Portal & Mobile App",
      "Healthcare Analytics Dashboard",
      "HIPAA Compliant & Secure"
    ],
    technologies: ["React", "FastAPI", "TensorFlow", "PostgreSQL", "AWS", "WebRTC"],
    useCases: [
      "Hospitals & Clinics",
      "Telemedicine Providers",
      "Private Practices",
      "Healthcare Networks"
    ]
  },
  {
    id: 2,
    name: "MediCare Manager",
    slug: "medicare-manager",
    category: "Healthcare SaaS",
    tagline: "Complete Healthcare Operations Management",
    description: "MediCare Manager streamlines healthcare operations with integrated billing, inventory, staff management, and patient engagement tools powered by AI.",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxoZWFsdGhjYXJlJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NjM5MzExMDl8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "Automated Billing & Insurance Claims",
      "Inventory & Supply Chain Management",
      "Staff Scheduling & Payroll",
      "Patient Engagement Tools",
      "Revenue Cycle Management",
      "Compliance Tracking",
      "Real-time Reporting & Analytics",
      "Multi-location Support"
    ],
    technologies: ["Vue.js", "Django", "MongoDB", "Redis", "Azure", "Docker"],
    useCases: [
      "Healthcare Facilities",
      "Medical Groups",
      "Urgent Care Centers",
      "Specialty Clinics"
    ]
  },
  {
    id: 3,
    name: "DataInsight Pro",
    slug: "datainsight-pro",
    category: "Data Science Platform",
    tagline: "Advanced Analytics & Business Intelligence Suite",
    description: "DataInsight Pro is an enterprise-grade data science platform that empowers organizations to extract actionable insights from complex data with AI-powered analytics and visualization.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxkYXRhJTIwYW5hbHl0aWNzfGVufDB8fHx8MTc2MzkzMTEwOXww&ixlib=rb-4.1.0&q=85",
    features: [
      "Automated Data Pipeline & ETL",
      "Predictive Analytics & ML Models",
      "Interactive Dashboards & Visualization",
      "Real-time Data Streaming",
      "Natural Language Queries",
      "Collaborative Workspaces",
      "Custom Report Generation",
      "API Integration & Export"
    ],
    technologies: ["Python", "Apache Spark", "Tableau", "Kafka", "Snowflake", "Kubernetes"],
    useCases: [
      "Enterprise Analytics",
      "Financial Services",
      "Retail & E-commerce",
      "Marketing Teams"
    ]
  }
];

export const jobOpenings = [
  {
    id: 1,
    title: "SAP Consultant",
    location: "Remote / Hybrid",
    type: "Full-Time",
    experience: "5+ years",
    description: "We are seeking an experienced SAP Consultant to help our clients optimize their business processes and implement SAP solutions.",
    responsibilities: [
      "Analyze business requirements and design SAP solutions",
      "Configure and customize SAP modules (SAP S/4HANA, SAP ERP)",
      "Provide technical and functional expertise in SAP implementations",
      "Conduct user training and create documentation",
      "Troubleshoot and resolve SAP-related issues",
      "Collaborate with cross-functional teams and stakeholders"
    ],
    requirements: [
      "5+ years of experience with SAP consulting",
      "Strong knowledge of SAP S/4HANA, SAP ERP, or SAP modules (FI, CO, MM, SD, etc.)",
      "Experience with SAP implementation methodologies (ASAP, Activate)",
      "Excellent problem-solving and analytical skills",
      "Strong communication and client-facing skills",
      "SAP certification preferred"
    ],
    benefits: [
      "Competitive salary and performance bonuses",
      "Health, dental, and vision insurance",
      "401(k) with company match",
      "Professional development and SAP training",
      "Flexible work arrangements",
      "Paid time off and holidays"
    ]
  },
  {
    id: 2,
    title: "Fullstack Software Engineer",
    location: "Remote / On-site",
    type: "Full-Time",
    experience: "3+ years",
    description: "Join our engineering team to build innovative web and mobile applications using modern technologies and AI-powered tools.",
    responsibilities: [
      "Design and develop scalable full-stack web applications",
      "Build responsive frontends using React, Vue, or Angular",
      "Develop robust backend APIs with Node.js, Python, or Java",
      "Integrate AI/ML features into applications",
      "Write clean, maintainable, and well-documented code",
      "Collaborate with designers, product managers, and other engineers",
      "Participate in code reviews and maintain CI/CD pipelines"
    ],
    requirements: [
      "3+ years of full-stack development experience",
      "Proficiency in JavaScript/TypeScript and modern frameworks (React, Vue, Angular)",
      "Strong backend experience with Node.js, Python (FastAPI/Django), or Java",
      "Experience with databases (PostgreSQL, MongoDB, MySQL)",
      "Knowledge of cloud platforms (AWS, Azure, GCP)",
      "Understanding of DevOps practices and CI/CD",
      "Bachelor's degree in Computer Science or related field (or equivalent experience)"
    ],
    benefits: [
      "Competitive salary based on experience",
      "Comprehensive health benefits",
      "Stock options or equity",
      "Learning and development budget",
      "Remote work flexibility",
      "Latest tech equipment and tools",
      "Team outings and company events"
    ]
  },
  {
    id: 3,
    title: "Salesforce Developer",
    location: "Remote",
    type: "Full-Time / Contract",
    experience: "4+ years",
    description: "We're looking for a skilled Salesforce Developer to design, develop, and implement Salesforce solutions for our diverse client base.",
    responsibilities: [
      "Develop custom Salesforce applications using Apex, Visualforce, and Lightning Web Components",
      "Configure and customize Salesforce platform (Sales Cloud, Service Cloud, etc.)",
      "Integrate Salesforce with third-party systems via REST/SOAP APIs",
      "Design and implement automation using Process Builder, Flow, and Apex Triggers",
      "Perform code reviews and ensure best practices",
      "Provide technical guidance and support to team members",
      "Stay updated with Salesforce releases and new features"
    ],
    requirements: [
      "4+ years of Salesforce development experience",
      "Strong proficiency in Apex, Visualforce, and Lightning Web Components (LWC)",
      "Experience with Salesforce APIs and integration patterns",
      "Knowledge of Sales Cloud, Service Cloud, or other Salesforce clouds",
      "Salesforce Platform Developer I/II certification required",
      "Experience with version control (Git) and deployment tools",
      "Excellent problem-solving and debugging skills"
    ],
    benefits: [
      "Competitive compensation package",
      "Health and wellness benefits",
      "401(k) retirement plan",
      "Salesforce certification reimbursement",
      "Flexible remote work",
      "Professional growth opportunities",
      "Collaborative and inclusive culture"
    ]
  }
];

export const aiCapabilities = [
  {
    id: 1,
    title: "Machine Learning",
    description: "Build intelligent systems that learn and improve from experience",
    icon: "brain"
  },
  {
    id: 2,
    title: "Deep Learning",
    description: "Neural networks for complex pattern recognition and decision making",
    icon: "network"
  },
  {
    id: 3,
    title: "NLP & LLMs",
    description: "Process and understand human language with advanced AI models",
    icon: "message-square"
  },
  {
    id: 4,
    title: "Computer Vision",
    description: "Extract insights from images and video with AI-powered analysis",
    icon: "eye"
  },
  {
    id: 5,
    title: "Predictive Analytics",
    description: "Forecast trends and outcomes using advanced AI algorithms",
    icon: "trending-up"
  },
  {
    id: 6,
    title: "AI Automation",
    description: "Automate complex processes with intelligent AI agents",
    icon: "zap"
  }
];

export const technologies = [
  {
    category: "AI & ML",
    items: ["TensorFlow", "PyTorch", "OpenAI GPT", "LangChain", "Hugging Face", "Scikit-learn"]
  },
  {
    category: "Backend",
    items: ["Python", "Node.js", "Java", "Go", "FastAPI", "Django"]
  },
  {
    category: "Frontend",
    items: ["React", "Vue.js", "Next.js", "TypeScript", "Tailwind CSS"]
  },
  {
    category: "Cloud & DevOps",
    items: ["AWS", "Azure", "GCP", "Docker", "Kubernetes", "Terraform"]
  },
  {
    category: "Data",
    items: ["PostgreSQL", "MongoDB", "Redis", "Apache Spark", "Kafka", "Snowflake"]
  }
];

export const industries = [
  {
    id: 1,
    name: "Financial Services",
    icon: "building-2",
    description: "AI-powered trading, fraud detection, and fintech solutions"
  },
  {
    id: 2,
    name: "Healthcare",
    icon: "heart-pulse",
    description: "Medical AI, healthcare IT, and clinical data systems"
  },
  {
    id: 3,
    name: "Retail & E-commerce",
    icon: "shopping-cart",
    description: "Personalization engines, inventory optimization, and smart retail"
  },
  {
    id: 4,
    name: "Manufacturing",
    icon: "factory",
    description: "Industrial AI, predictive maintenance, and smart manufacturing"
  },
  {
    id: 5,
    name: "Technology",
    icon: "cpu",
    description: "SaaS development, platform engineering, and tech innovation"
  },
  {
    id: 6,
    name: "Telecommunications",
    icon: "radio",
    description: "Network optimization, AI-powered customer service"
  }
];

export const stats = [
  {
    id: 1,
    number: "500+",
    label: "Projects Delivered",
    icon: "briefcase"
  },
  {
    id: 2,
    number: "200+",
    label: "AI Models Deployed",
    icon: "brain"
  },
  {
    id: 3,
    number: "98%",
    label: "Client Satisfaction",
    icon: "star"
  },
  {
    id: 4,
    number: "15+",
    label: "Years Experience",
    icon: "award"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "AI Expertise",
    description: "Cutting-edge AI and machine learning capabilities with proven track record in production deployments.",
    icon: "lightbulb"
  },
  {
    id: 2,
    title: "Full-Stack Excellence",
    description: "End-to-end software development from frontend to backend, cloud infrastructure to AI integration.",
    icon: "layers"
  },
  {
    id: 3,
    title: "Top-Tier Talent",
    description: "Access to pre-vetted software engineers, AI specialists, and data scientists ready to deliver.",
    icon: "user-check"
  },
  {
    id: 4,
    title: "Agile Delivery",
    description: "Fast, iterative development with continuous deployment and modern DevOps practices.",
    icon: "rocket"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    position: "CTO, TechVision Inc",
    company: "TechVision Inc",
    image: "https://images.unsplash.com/photo-1689600944138-da3b150d9cb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MzkzMjMxNXww&ixlib=rb-4.1.0&q=85",
    quote: "OneIT Solutions transformed our business with their AI-powered analytics platform. Their team's expertise in machine learning and data science helped us increase efficiency by 40%.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    position: "VP of Engineering, DataFlow Systems",
    company: "DataFlow Systems",
    image: "https://images.unsplash.com/photo-1652471943570-f3590a4e52ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MzkzMjMxNXww&ixlib=rb-4.1.0&q=85",
    quote: "The full-stack development team from OneIT delivered our cloud-native application ahead of schedule. Their DevOps expertise and agile approach made the entire process seamless.",
    rating: 5
  },
  {
    id: 3,
    name: "James Rodriguez",
    position: "Director of IT, FinanceHub",
    company: "FinanceHub",
    image: "https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg",
    quote: "Outstanding cybersecurity services! OneIT's team conducted a thorough security audit and implemented robust solutions that exceeded our compliance requirements.",
    rating: 5
  },
  {
    id: 4,
    name: "Emily Watson",
    position: "Chief Data Officer, RetailPro",
    company: "RetailPro",
    image: "https://images.unsplash.com/photo-1689600944138-da3b150d9cb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MzkzMjMxNXww&ixlib=rb-4.1.0&q=85",
    quote: "Their data science team built predictive models that revolutionized our inventory management. The ROI was evident within the first quarter of implementation.",
    rating: 5
  }
];

export const clientLogos = [
  { id: 1, name: "TechVision Inc" },
  { id: 2, name: "DataFlow Systems" },
  { id: 3, name: "FinanceHub" },
  { id: 4, name: "RetailPro" },
  { id: 5, name: "CloudNine Corp" },
  { id: 6, name: "InnovateAI" },
  { id: 7, name: "SecureNet" },
  { id: 8, name: "HealthTech Solutions" }
];
